















































































import Vue from "vue";
import Component from "vue-class-component";
import { ReportDetail_report_attachments } from "@/models/queries/types/ReportDetail";
import { Fragment } from "vue-fragment";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import { UserService } from "@/services/UserService";
import { ReportOverview } from "@/models/queries/ReportOverviewQuery";
import { DataValidation, DataProgress } from "@/models/graphql-global-types";
import lodash from "lodash";

@Component({
  props: {
    report: Object,
    selectedProgress: Array,
    selectedDataValidations: Array,
    selectedScrewDiameter: String,
    filteredSheets: Array,
    setScrewDiameter: Function,
    setProgress: Function,
    setDataValidation: Function
  },
  components: {
    Fragment,
    ClipLoader
  }
})
export default class SheetCardsFilter extends Vue {
  private isUserAdmin = UserService.isUserAdmin;
  private isUserTester = UserService.isUserTester;
  private isUserViewer = UserService.isUserViewer;
  private DataProgress = DataProgress;
  private DataValidation = DataValidation;

  get screwDiameterOptions() {
    return lodash.uniq(this.$props.report.sheets.flatMap(s => s.product.screwDiameter));
  }

  public isUserOwnerOfReport() {
    return UserService.isUserOwnerOfReport(this.$props.report);
  }
}
